import "i18next";
import type translations from "../../locales/en/ds.json";

declare module "i18next" {
  interface ResourceNamespaceMap {
    ds: typeof translations;
  }
}
